import CRMPermission from '@/models/enums/permissions/CRMPermission'
import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/sources',
    name: RouteName.Sources,
    component: () => import('@/pages/Sources/SourceList.vue'),
    meta: {
      permissions: [CRMPermission.Sources],
      breadcrumb: {
        label: 'Источники',
        parent: RouteName.Settings,
      },
    },
  },
  {
    path: '/sources/create',
    name: 'source-create',
    component: () => import('@/pages/Sources/SourceForm.vue'),
    meta: {
      permissions: [CRMPermission.Sources],
      breadcrumb: {
        label: 'Новый источник',
        parent: RouteName.Sources,
      },
    },
  },
  {
    path: '/sources/:id',
    name: 'source-edit',
    component: () => import('@/pages/Sources/SourceForm.vue'),
    props: { isEdit: false },
    meta: {
      permissions: [CRMPermission.Sources],
      breadcrumb: {
        label: 'Редактирование источника',
        parent: RouteName.Sources,
      },
    },
  },
]
